/* eslint-disable prettier/prettier */
import React from 'react';
import { CalendarViewMode } from '../../types/schedule.types';
import { MONTHS_LONG } from '../../utils/dateUtils';
import styles from '../../styles/scheduler/CalendarHeader.module.css';

interface CalendarHeaderProps {
	month: number;
	year: number;
	calendarView: CalendarViewMode;
	onPrev: () => void;
	onNext: () => void;
	onMonthClick: () => void;
	onYearClick: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({
	month,
	year,
	calendarView,
	onPrev,
	onNext,
	onMonthClick,
	onYearClick,
}) => (
	<div className={styles.header}>
		<button className={styles.nav} onClick={onPrev} aria-label="Previous">
			‹
		</button>
		<div className={styles.selectors}>
			<button
				className={`${styles.btn} ${calendarView === 'month' ? styles.btnActive : ''}`}
				onClick={onMonthClick}
			>
				{MONTHS_LONG[month]} <span className={styles.chevron}>▾</span>
			</button>
			<button
				className={`${styles.btn} ${calendarView === 'year' ? styles.btnActive : ''}`}
				onClick={onYearClick}
			>
				{year} <span className={styles.chevron}>▾</span>
			</button>
		</div>
		<button className={styles.nav} onClick={onNext} aria-label="Next">
			›
		</button>
	</div>
);

export default CalendarHeader;
